<template>
<vendor-page-template>
  <agent-login-window/>
</vendor-page-template>
</template>
<script>
const VendorPageTemplate = () => import('@/components/pages/vendor/VendorPageTemplate')
const AgentLoginWindow = () => import('@/components/pages/Agent/newAgent/AgentLoginWindow')
export default {
	components: {
		VendorPageTemplate,
		AgentLoginWindow
	}
}
</script>
